import React from 'react';

const notificationPopoverContext = React.createContext({ popoverHeaderRef: null, notificationRef: null });

export default notificationPopoverContext;
